// extracted by mini-css-extract-plugin
var _1 = "glowingText-module__glowingText___Iu87i";
export { _1 as "glowingText" }
